import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnswerSchema, CustomTest, QuestionSchema, TestGroup } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
declare var Quill: any;
declare var $: any;

@Component({
  selector: 'app-create-custom-tests',
  templateUrl: './create-custom-tests.component.html',
  styleUrls: ['./create-custom-tests.component.css']
})
export class CreateCustomTestsComponent implements OnInit {

  public customTest: CustomTest = {
    title: '',
    description: {},
    questions: [],
    timer: false,
    randomQty: 0,
    groupId: '',
    groupName: '',
    random: false,
    active: false,
    timerQty: 0,
    secureTest: false,
    canGoBack: false,
    userId: ''
  }

  public question: QuestionSchema = {
    question: {},
    instructions: {},
    answers: [],
    questionImage: '',
    answerImage: '',
    type: 'text',
    explanation: {},
    instructionsTimer: 0,
    customPlaceholder: '',
    canChangeAnswer: true,
    questionTimer: 0
  }

  public answer: AnswerSchema = {
    title: '',
    correct: false,
    requestInput: false
  }

  public editingAnswerIndex = -1;
  public editingQuestionIndex = -1;

  public descriptionEditor: any;
  public questionEditor: any;
  public instructionsEditor: any;
  public explanationEditor: any;
  public editingId: string = '';

  public groups: TestGroup[] = []

  public user;

  constructor(
    private testService: TestService,
    private customTestService: CustomTestService,
    private route: ActivatedRoute,
    private userService: UserService
  ) { }

  async ngOnInit() {
    this.user = await this.userService.getUser().toPromise()

    let isDuplicate = this.route.snapshot.queryParamMap.get('duplicate')
    let editingId = this.route.snapshot.queryParamMap.get('editingId')
    if (editingId){
      this.editingId = editingId
      this.customTestService.getCustomTests({_id: editingId}).subscribe((res:any)=>{
        this.customTest = res[0]
        setTimeout(() => {
          this.initEditors()
          this.descriptionEditor.setContents(this.customTest.description)
          if (isDuplicate == 'true'){
            this.editingId = ''
            delete this.customTest._id;
          }
          if (this.user.role != 'admin'){
            this.customTest.userId = this.user._id
            this.customTest.groupId = ''
          }else{
            this.customTest.userId = ''
          }
        }, 1000)
      })
    }else{
      setTimeout(() => {
        this.initEditors()
      }, 1000)
    }

    let query = {}
    if (this.user.role != 'admin'){
      query = {
        userId: this.user._id
      }
    }else{
      query = {
        active: true
      }
    }

    this.groups = await this.customTestService.getTestGroups(query).toPromise()
    if (this.user.role != 'admin'){
      this.groups = this.groups.filter(group => group.userId === this.user._id)
    }

  }

  getHtmlContent(data: any){
    let content = data.ops[0].insert
    return content
  }


  initEditors(){
    var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
    
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
    
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['link'],
    
    ];
    var options = {
      modules: {
        toolbar: toolbarOptions
      },
      placeholder: 'Escribe aquí',
      theme: 'snow'
    };

    this.descriptionEditor = new Quill('.description-editor', options)
    this.questionEditor = new Quill('.question-editor', options)
    options.placeholder = 'Escribe (si lo necesitas), el texto visible por arriba de la pregunta, ej: "Lee cada pregunta cuidadosamente antes de responder".'
    this.instructionsEditor = new Quill('.instructions-editor', options)
    options.placeholder = 'Escribe la explicación que se mostrará en el reporte cuando el evaluado responda incorrectamente. Aquí puedes detallar por qué la respuesta correcta es la correcta.'
    this.explanationEditor = new Quill('.explanation-editor', options)

  }

  create(){
    if (this.user.role != 'admin'){
      this.customTest.userId = this.user._id
    }
    this.customTest.description = this.descriptionEditor.getContents()
    if (!this.editingId){
      this.customTestService.createCustomTest(this.customTest).subscribe((res:any)=>{
        Swal.fire({
          text: 'Test creado correctamente',
          icon: 'success'
        }).then(()=>{
          location.reload()
        })
      })
    }else{
      let obj = Object.assign({}, this.customTest)
      delete obj.questions;
      this.customTestService.updateCustomTest(obj, this.editingId).subscribe((res:any)=>{
        Swal.fire({
          text: 'Test actualizado correctamente',
          icon: 'success'
        })
      })

    }
  }


  uploadImage(event:any, forAnswer:boolean = false){
    let image = event.target.files[0];
    this.testService.uploadImage(image).subscribe((res:any)=>{
      if (!forAnswer){
        this.question.questionImage = res.secure_url
      }else{
        this.question.answerImage = res.secure_url
      }
    })
  }

  addAnswer(){
    if (!this.question.canChangeAnswer && this.question.type == 'conditional' && !this.answer.requestInput){
      return Swal.fire({
        icon: 'info',
        text: 'No puede agregar una respuesta con el campo "Ingresar respuesta" y "¿Puede modificar respuesta?" ambos desactivados'
      })
    }
    if (this.answer.title === '') return
    if (this.editingAnswerIndex !== -1){
      this.question.answers[this.editingAnswerIndex] = {...this.answer}
      this.editingAnswerIndex = -1
      this.answer = {
        title: '',
        correct: false,
        requestInput: false
      }
      return
    }
    this.question.answers.push({...this.answer})
    this.answer = {
      title: '',
      correct: false,
      requestInput: false
    }
  }

  handleDeleteAnswer(index:number){
    Swal.fire({
      text: '¿Estás seguro de eliminar esta respuesta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then( resp => {
      if (resp.isConfirmed){

        this.question.answers.splice(index, 1)
        
      }
    }) 
  }

  handleEditAnswer(index:number){
    this.answer = {...this.question.answers[index]}
    this.editingAnswerIndex = index
  }

  async addQuestion(){
    // console.log(this.customTest.questions[this.editingQuestionIndex].explanation)
    // console.log(this.explanationEditor)
    // console.log(this.explanationEditor.getContents())

    if ( this.question.type != 'text' && this.question.answers.length === 0){
      return Swal.fire({
        icon: 'info',
        text: 'Debe agregar al menos una respuesta'
      })
    }

    if (this.question.type == 'multiple'){
      let correctQty = this.question.answers.filter(answer => answer.correct).length
      if (correctQty < 2){
        return Swal.fire({
          icon: 'info',
          text: 'Debe agregar al menos dos respuestas correctas'
        })
      }
    }

    let someCorrectAnswer = this.question.type == 'text' || this.question.answers.some(answer => answer.correct)

    if (!someCorrectAnswer){
      return Swal.fire({
        icon: 'info',
        text: 'Debe agregar al menos una respuesta correcta'
      })
    }

    if (!this.editingId){
      let obj = Object.assign({}, this.customTest)
      delete obj.questions;
      let response = await this.customTestService.createCustomTest(obj).toPromise()
      this.editingId = response._id
      let newQuestions = []
      for (let question of this.customTest.questions){
        let newQuestion = await this.customTestService.updateTestQuestion(this.editingId, question).toPromise()
        newQuestions.push(newQuestion)
      }
      this.customTest.questions = newQuestions
    }

    if (this.editingQuestionIndex !== -1){
      // if (!this.customTest.questions[this.editingQuestionIndex].explanation){
      //   this.customTest.questions[this.editingQuestionIndex].explanation = {}
      // }
      this.customTest.questions[this.editingQuestionIndex] = {...this.question}
      // console.log(this.customTest.questions[this.editingQuestionIndex].explanation)
      this.customTest.questions[this.editingQuestionIndex].question = this.questionEditor.getContents()
      this.customTest.questions[this.editingQuestionIndex].instructions = this.instructionsEditor.getContents()
      this.customTest.questions[this.editingQuestionIndex].explanation = this.explanationEditor.getContents()
      this.customTestService.updateTestQuestion(this.editingId, this.customTest.questions[this.editingQuestionIndex]).subscribe((res:any)=>{
      })
      this.editingQuestionIndex = -1
      this.question = {
        question: {},
        instructions: {},
        answers: [],
        questionImage: '',
        answerImage: '',
        type: 'text',
        explanation: {},
        instructionsTimer: 0,
        customPlaceholder: '',
        canChangeAnswer: true,
        questionTimer: 0
      }
      this.questionEditor.setContents()
      this.instructionsEditor.setContents()
      this.explanationEditor.setContents()
      $('.question-modal').modal('hide') 
      return
    }
    this.question.question = this.questionEditor.getContents()
    this.question.instructions = this.instructionsEditor.getContents()
    this.question.explanation = this.explanationEditor.getContents()
    // this.customTest.questions.push({...this.question})
    this.customTestService.updateTestQuestion(this.editingId, this.question).subscribe((res:any)=>{
      this.customTest.questions.push(res)
    })

    this.question = {
      question: {},
      instructions: {},
      answers: [],
      questionImage: '',
      answerImage: '',
      type: 'text',
      explanation: {},
      instructionsTimer: 0,
      customPlaceholder: '',
      canChangeAnswer: true,
      questionTimer: 0
    }
    this.questionEditor.setContents()
    this.instructionsEditor.setContents()
    this.explanationEditor.setContents()
    $('.question-modal').modal('hide') 

  }

  handleEditQuestion(index:number){
    this.question = {...this.customTest.questions[index]}
    if (this.question.explanation === undefined){
      this.question.explanation = {}
    }
    this.questionEditor.setContents(this.question.question)
    this.instructionsEditor.setContents(this.question.instructions)
    if (this.question.explanation){
      this.explanationEditor.setContents(this.question.explanation)
    }
    this.editingQuestionIndex = index
    $('.question-modal').modal('show')
  }

  handleDeleteQuestion(index:number){
    Swal.fire({
      text: '¿Estás seguro de eliminar esta pregunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then( resp => {
      if (resp.isConfirmed){
        this.customTestService.deleteTestQuestion(this.editingId, this.customTest.questions[index]._id).subscribe((res:any)=>{
          // console.log(res)
          this.customTest.questions.splice(index, 1)
        })
      }
    })
  }

  handleEditHtml(editor: string){
    switch (editor) {
      case 'q-description':
        
        break;
    }
  }

  moveArrayIndex(index:number, direction: number){
    let newIndex = index + direction
    this.customTestService.updateTestQuestionOrder(this.editingId, index, newIndex).subscribe()
    let temp = this.customTest.questions[newIndex]
    this.customTest.questions[newIndex] = this.customTest.questions[index]
    this.customTest.questions[index] = temp
  }

  handleNewQuestion(){
    this.editingQuestionIndex = -1
    this.question = {
      question: {},
      instructions: {},
      answers: [],
      answerImage: '',
      questionImage: '',
      type: 'text',
      explanation: {},
      instructionsTimer: 0,
      customPlaceholder: '',
      questionTimer: 0
    }
    this.questionEditor.setContents()
    this.instructionsEditor.setContents()
    this.explanationEditor.setContents()
    $('.question-modal').modal('show')
  }

  handleNewAnswer(){
    this.editingAnswerIndex = -1
    this.answer = {
      title: '',
      correct: false,
      requestInput: false
    }
    
  }

  setGroupName(id: any){
    let group = this.groups.find(g => g._id === id)
    this.customTest.groupName = group.title
  }

}
